export const embedPlaceholderModifier = () => {

    const videoWrapper = document.querySelector('.section-invent-info .video-box .video-wrapper');
    if(videoWrapper) {

        const addOrRemoveHasEmbedPlaceholderClass = () => {
            const embedPlaceholder = videoWrapper.querySelector('.embed_placeholder');
            if(embedPlaceholder) {
                videoWrapper.classList.add('has-embed-placeholder');
            } else {
                videoWrapper.classList.remove('has-embed-placeholder');
            }
        }

        //Run on initial
        window.setTimeout(() => {
            addOrRemoveHasEmbedPlaceholderClass();
        },500);

        // Options for the observer (which mutations to observe)
        const config = { childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = function(mutationsList, observer) {
            // Use traditional 'for loops' for IE 11
            for(const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    addOrRemoveHasEmbedPlaceholderClass();
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(videoWrapper, config);

        // Later, you can stop observing
        observer.disconnect();
    }
}